module.exports = __webpack_public_path__ + "media/alarm-sound.2ced1bcb.mp3";